module.exports = __webpack_public_path__ + "static/media/buxton-12.358060d0.jpg";